import { useEffect, useState } from 'react'
import { settingsApi } from '../sdk/settings.api'
import { getShop }     from '../sdk/shop'

export type EnabledModules = {
  confirmation:         boolean
  sales:                boolean
  shippingConfirmation: boolean
  customerService:      boolean
  deliveryTracking:     boolean
}

const ALL_ENABLED: EnabledModules = {
  confirmation:         true,
  sales:                true,
  shippingConfirmation: true,
  customerService:      true,
  deliveryTracking:     false,
}

export function useEnabledModules(): EnabledModules {
  const shop = getShop()
  const [modules, setModules] = useState<EnabledModules>(ALL_ENABLED)

  useEffect(() => {
    if (!shop) return
    Promise.allSettled([
      settingsApi.getConfirmationConfig(shop),
      settingsApi.getSalesConfig(shop),
      settingsApi.getShippingConfirmationConfig(shop),
      settingsApi.getCsConfig(shop),
      settingsApi.getDeliveryTrackingConfig(shop),
    ]).then(([cf, st, sc, cs, dt]) => {
      setModules({
        confirmation:         cf.status === 'fulfilled' ? cf.value.enabled : false,
        sales:                st.status === 'fulfilled' ? st.value.enabled : false,
        shippingConfirmation: sc.status === 'fulfilled' ? sc.value.enabled : false,
        customerService:      cs.status === 'fulfilled' ? cs.value.enabled : false,
        deliveryTracking:     dt.status === 'fulfilled' ? dt.value.enabled : false,
      })
    })
  }, [shop])

  return modules
}
